import { useState, useEffect } from "react";

const WhatsAppButton = () => {
  const [iconSize, setIconSize] = useState("80px");

  useEffect(() => {
    const handleResize = () => {
      setIconSize(window.innerWidth < 768 ? "50px" : "80px");
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <a
      href="https://wa.me/+919265197287"
      target="_blank"
      rel="noopener noreferrer"
      style={{
        position: "fixed",
        bottom: "2vh",
        right: "1vw",
        zIndex: 9999,
        backgroundColor: "#59CE72",
        borderRadius: "50%",
        width: iconSize,
        height: iconSize,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        transition: "transform 0.3s ease",
      }}
      onMouseOver={(e) => (e.currentTarget.style.transform = "scale(1.1)")}
      onMouseOut={(e) => (e.currentTarget.style.transform = "scale(1)")}
    >
      <img
        src="/WhatsAppLogo.svg"
        alt="WhatsApp Logo"
        loading="lazy"
        style={{ width: "60%", height: "60%" }}
      />
    </a>
  );
};

export default WhatsAppButton;
